import { render, staticRenderFns } from "./AddEndDate.vue?vue&type=template&id=6be72da2&scoped=true&"
import script from "./AddEndDate.vue?vue&type=script&lang=js&"
export * from "./AddEndDate.vue?vue&type=script&lang=js&"
import style0 from "./AddEndDate.vue?vue&type=style&index=0&id=6be72da2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be72da2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Volumes/Crucial2TB/Main Portfolio/TOTUMO/Projects/Man Power/Experis/reporte-novedades/ctg-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDatePicker,VDivider,VFlex,VMenu,VSpacer,VTextField})
